module.exports = __webpack_public_path__ + "static/media/preloader.b36d1321.GIF";